import type { JSX } from "react";

import { newReportAction } from "../applicationBarActions";
import { ReportColumnId, REPORT_COLUMN_IDS } from "../columns";
import { ReportsListLayout } from "../layout";

function ReportsDatasheetPage(): JSX.Element {
    return (
        <ReportsListLayout
            pageType="Datasheet"
            columnIds={COLUMN_IDS}
            actions={[newReportAction("Datasheet")]}
        />
    );
}

const COLUMN_IDS: Array<ReportColumnId> = [
    REPORT_COLUMN_IDS.DATASHEET,
    REPORT_COLUMN_IDS.CONTROL_PROGRAM,
    REPORT_COLUMN_IDS.DATASHEET_ARCHIVED,
];

export { ReportsDatasheetPage };
